// R116 #1: a used / expired invite or reset link (main.ts, verifyOtp failed) —
// the same shell, one blue action back to sign-in.
import { authCardHtml, mountAuthScreen, noticeHtml } from './AuthShell';

export function renderExpiredLink(container: HTMLElement): void {
  mountAuthScreen(container, authCardHtml({
    screen: 'expired',
    hello: '<b>Let’s get you a fresh link</b>',
    body: `
      ${noticeHtml({ tone: 'warn', id: 'expired-note', text: 'This sign-in link has expired or was already used.' })}
      <p class="au-helper au-helper-left">Ask your admin to tap <b>Resend invite</b> on your account — the new link arrives right away. Already set a password? Just sign in.</p>
      <button type="button" class="au-btn" id="expired-go" data-au-magnet><span class="au-btn-t">Go to sign in</span></button>`,
  }));
  const go = document.getElementById('expired-go') as HTMLButtonElement | null;
  go?.addEventListener('click', () => { window.location.href = '/'; });
  go?.focus();
}
